import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    this.onClick = this.onClick.bind(this);
    this.onKeydown = this.onKeydown.bind(this);
    this.element.addEventListener("click", this.onClick, true);
  }

  disconnect() {
    this.close();
    this.element.removeEventListener("click", this.onClick, true);
    this.onClick = null;
    this.onKeydown = null;
  }

  onClick(event) {
    const wrapper = event.target.closest(".bp-video-blob-wrapper");
    if (!wrapper) return;

    const link = wrapper.closest("a");
    if (!link) return;

    let videoUrl = link.dataset.videoUrl;
    if (!videoUrl) {
      const attachment = link.closest("action-text-attachment");
      if (attachment) videoUrl = attachment.getAttribute("url");
    }
    if (!videoUrl) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const poster = link.querySelector(".bp-video-poster, img");
    const posterSrc = poster ? poster.getAttribute("src") : null;

    this.open(videoUrl, posterSrc);
  }

  onKeydown(event) {
    if (!this.overlay) return;
    if (event.key === "Escape") this.close();
  }

  open(videoUrl, posterSrc) {
    this.close();

    this.videoUrl = videoUrl;

    const overlay = document.createElement("div");
    overlay.className = "bp-image-lightbox";
    overlay.setAttribute("role", "dialog");
    overlay.setAttribute("aria-modal", "true");

    const closeButton = this.buildButton("bp-image-lightbox-close", "Close", "&times;");

    const downloadButton = this.buildButton(
      "bp-image-lightbox-download",
      "Download",
      '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>'
    );
    downloadButton.addEventListener("click", (event) => {
      event.stopPropagation();
      this.download();
    });

    const video = document.createElement("video");
    video.className = "bp-image-lightbox-image";
    video.src = videoUrl;
    video.controls = true;
    video.autoplay = true;
    video.playsInline = true;
    if (posterSrc) video.poster = posterSrc;

    const stage = document.createElement("div");
    stage.className = "bp-image-lightbox-stage";
    stage.appendChild(closeButton);
    stage.appendChild(downloadButton);
    stage.appendChild(video);

    overlay.appendChild(stage);

    overlay.addEventListener("click", (event) => {
      if (event.target === overlay || event.target === closeButton) {
        this.close();
      }
    });

    document.body.appendChild(overlay);
    document.body.style.overflow = "hidden";

    this.overlay = overlay;
    this.videoElement = video;

    document.addEventListener("keydown", this.onKeydown);

    const playPromise = video.play();
    if (playPromise && typeof playPromise.catch === "function") {
      playPromise.catch(() => {});
    }
  }

  buildButton(className, label, glyph) {
    const button = document.createElement("button");
    button.type = "button";
    button.className = className;
    button.setAttribute("aria-label", label);
    button.innerHTML = glyph;
    return button;
  }

  async download() {
    if (!this.videoUrl) return;
    const src = this.videoUrl;
    let filename = "video";
    try {
      const url = new URL(src, window.location.href);
      const last = url.pathname.split("/").filter(Boolean).pop();
      if (last) filename = decodeURIComponent(last);
    } catch (_e) {}

    try {
      const response = await fetch(src, { credentials: "omit" });
      if (!response.ok) throw new Error("fetch failed");
      const blob = await response.blob();
      const objectUrl = URL.createObjectURL(blob);
      const anchor = document.createElement("a");
      anchor.href = objectUrl;
      anchor.download = filename;
      document.body.appendChild(anchor);
      anchor.click();
      anchor.remove();
      URL.revokeObjectURL(objectUrl);
    } catch (_e) {
      window.open(src, "_blank", "noopener");
    }
  }

  close() {
    if (!this.overlay) return;

    if (this.videoElement) {
      try { this.videoElement.pause(); } catch (_e) {}
      this.videoElement.removeAttribute("src");
      try { this.videoElement.load(); } catch (_e) {}
    }

    this.overlay.remove();
    document.body.style.overflow = "";
    if (this.onKeydown) document.removeEventListener("keydown", this.onKeydown);

    this.overlay = null;
    this.videoElement = null;
    this.videoUrl = null;
  }
}
